import { forwardRef, PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

import './TableRow.scss'

interface TableRowProps extends PropsWithChildren {
    hasHoverState?: boolean;
    loading?: boolean;
    onClick?: () => void;
    className?: string;
}

const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(({
    hasHoverState,
    loading = false,
    onClick = undefined,
    className = '',
    children,
}, ref): ReactElement => {
    const tableRowClassName = classNames('table-row', {
        'table-row--has-hover-state': hasHoverState,
        'table-row--is-clickable': !! onClick,
        'table-row--is-loading': loading,
    }, className)

    return (
        <tr ref={ref} className={tableRowClassName} onClick={onClick}>
            {children}
        </tr>
    )
})

export default TableRow
